import { BGCOption } from './types'

export const yardstikOption: BGCOption = {
  value: 'yardstik',
  label: 'Use Yardstick to conduct Background Check & Motor Vehicle Record Report',
}

export const manualOption: BGCOption = {
  value: 'manual',
  label: 'I want to manually upload Background Check & Motor Vehicle Record file',
}

export const skipOption: BGCOption = {
  value: 'skip',
  label: 'I want to proceed without Background Check & Motor Vehicle Record Report',
}
